export default __webpack_public_path__ + "static/media/20.d236bab4.mp3";